var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopyTrading = function SvgCopyTrading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.763 10.556a.783.783 0 0 0-.783-.783H6.44a.783.783 0 0 0 0 1.566h2.54c.433 0 .783-.35.783-.783M12.551 12.661a.783.783 0 1 1 0 1.566h-6.11a.783.783 0 1 1 0-1.566z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.58 7.24A4.74 4.74 0 0 1 7.32 2.5h5.592c.944 0 1.825.276 2.564.753l3.757 1.452a3.92 3.92 0 0 1 2.115 5.368l-3.923 8.098-.003-.001a4.8 4.8 0 0 1-4.57 3.33H4.667a2.09 2.09 0 0 1-2.087-2.088zm4.74-3.16h5.592a3.16 3.16 0 0 1 3.16 3.16v9.46a3.22 3.22 0 0 1-3.22 3.22H4.667a.51.51 0 0 1-.508-.508V7.24a3.16 3.16 0 0 1 3.16-3.16m10.331 10 2.275-4.696a2.34 2.34 0 0 0-1.263-3.205l-1.272-.492c.169.486.26 1.009.26 1.552z",
    clipRule: "evenodd"
  })));
};
export default SvgCopyTrading;